import React from 'react';
import { BsCheckLg } from 'react-icons/bs';
import { FaArrowRight } from 'react-icons/fa';



const CourseCard = ({ courses }) => {

    let eachHighlight;
    if (courses.highlights) {
        eachHighlight = courses.highlights.map((highlight, index) => {
            return (
                <p key={index} className='flex gap-4 items-center pb-3'><BsCheckLg color='green' />{highlight}</p>
            );
        });
    } else {
        eachHighlight = null
    }

    let enrollments;
    if (courses.enrollments) {
        enrollments = Object.entries(courses.enrollments).map(([key, value]) => (
            <div key={key} className='text-center p-4 rounded-lg bg-white border border-gray-200' >
                <p className='text-lg md:text-xl font-bold text-gray-900'>{value}</p>
                <p className='text-xs md:text-sm text-gray-600 mt-1'>{key.charAt(0).toUpperCase() + key.slice(1)}</p>
            </div>
        ));
    } else {
        material = null
    }

    let offers;
    if (courses.offers) {
        offers = courses.offers.map((offer, index) => {
            return (
                <p key={index} className="text-sm text-gray-700 font-medium">{offer}</p>
            );
        });
    } else {
        offers = null
    }

    let material;
    if (courses.material) {
        material = Object.entries(courses.material).map(([key, value]) => (
            <div key={key}>
                <p className='font-medium'>{key}</p>
                <p className='pb-2'>{value}</p>
            </div>
        ));
    } else {
        material = null
    }

    return (
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
            {/* Header Section */}
            <div className="bg-gradient-to-r from-purple-600 to-indigo-600 px-6 md:px-8 py-8">
                <h2 className='text-white text-2xl md:text-3xl font-bold m-0' id={courses.pageId}>
                    {courses.name}
                </h2>
            </div>

            {/* Video Section */}
            <div className="px-6 md:px-8 py-6">
                <div className="w-full rounded-xl overflow-hidden shadow-md">
                    <iframe
                        className='w-full'
                        style={{ height: '320px' }}
                        src={courses.videoId}
                        title="Course video"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen>
                    </iframe>
                </div>
            </div>

            {/* Content Grid */}
            <div className="px-6 md:px-8 py-6 grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* What You'll Learn */}
                {eachHighlight && (
                    <div>
                        <h3 className='text-gray-900 font-bold text-lg mb-4'>O que você aprenderá</h3>
                        <ul className='space-y-3'>
                            {courses.highlights && courses.highlights.map((highlight, index) => (
                                <li key={index} className='flex gap-3 items-start text-gray-700'>
                                    <BsCheckLg className='text-green-500 flex-shrink-0 mt-1' />
                                    <span className='text-sm'>{highlight}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                {/* Material */}
                {material && (
                    <div>
                        <h3 className='text-gray-900 font-bold text-lg mb-4'>Material do Curso</h3>
                        <div className='space-y-4 text-gray-700 text-sm'>
                            {courses.material && Object.entries(courses.material).map(([key, value]) => (
                                <div key={key} className='pb-4 border-b border-gray-200 last:border-b-0'>
                                    <p className='font-semibold text-gray-900 mb-1'>{key}</p>
                                    <p className='text-gray-600'>{value}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            {/* Stats Section */}
            {enrollments && (
                <div className="px-6 md:px-8 py-6 bg-gray-50 border-t border-gray-200">
                    <div className='grid grid-cols-2 md:grid-cols-3 gap-4'>
                        {enrollments}
                    </div>
                </div>
            )}

            {/* CTA Section */}
            <div className="px-6 md:px-8 py-6 bg-gradient-to-r from-orange-50 to-red-50 border-t border-gray-200">
                <div className='flex flex-col sm:flex-row items-center justify-between gap-4'>
                    <div className='flex-1'>
                        {offers && <div className='text-sm text-gray-600'>{offers}</div>}
                        <p className='text-xs text-gray-500 mt-2'>*Você será direcionado para o site do curso</p>
                    </div>
                    <a
                        href={courses.purchaseUrl}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='bg-gradient-to-r from-orange-500 to-red-500 text-white px-6 py-3 rounded-full font-semibold flex items-center gap-2 hover:shadow-lg transition-all duration-300 hover:from-orange-600 hover:to-red-600 whitespace-nowrap'
                    >
                        Comprar Curso
                        <FaArrowRight size={14} />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default CourseCard;
